import { CartItemResultActionsRenderTargetComponent } from './targets/cart-item-result-actions.render-target.component';
import { CartItemResultDescriptionRenderTargetComponent } from './targets/cart-item-result-description.render-target.component';
import { CartItemResultExtendedRenderTargetComponent } from './targets/cart-item-result-extended.render-target.component';
import { CartItemResultImagesRenderTargetComponent } from './targets/cart-item-result-images.render-target.component';
import { CartItemResultInfoRenderTargetComponent } from './targets/cart-item-result-info.render-target.component';
import { CartItemResultNoticeRenderTargetComponent } from './targets/cart-item-result-notice.render-target.component';
import { CartItemResultSummaryRenderTargetComponent } from './targets/cart-item-result-summary.render-target.component';
import { CartItemResultTitleRenderTargetComponent } from './targets/cart-item-result-title.render-target.component';

export enum CartItemResultRenderTarget {
  Images = 'images',
  Title = 'title',
  Description = 'description',
  Notice = 'notice',
  Summary = 'summary',
  Actions = 'actions',
  Info = 'info',
  Extended = 'extended',
}

export const CartItemResultRenderTargetComponents = {
  [CartItemResultRenderTarget.Images]: CartItemResultImagesRenderTargetComponent,
  [CartItemResultRenderTarget.Title]: CartItemResultTitleRenderTargetComponent,
  [CartItemResultRenderTarget.Notice]: CartItemResultNoticeRenderTargetComponent,
  [CartItemResultRenderTarget.Description]: CartItemResultDescriptionRenderTargetComponent,
  [CartItemResultRenderTarget.Summary]: CartItemResultSummaryRenderTargetComponent,
  [CartItemResultRenderTarget.Actions]: CartItemResultActionsRenderTargetComponent,
  [CartItemResultRenderTarget.Info]: CartItemResultInfoRenderTargetComponent,
  [CartItemResultRenderTarget.Extended]: CartItemResultExtendedRenderTargetComponent,
} as const;
